module.exports = __webpack_public_path__ + "static/img/partner-logo-14.9d564a92.png";